import { freeze } from 'icepick';
import { CORE_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { SET, type SetAction } from './actions.tsx';
import type { Project } from './types.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type ProjectState = Project;

export const initialState: ProjectState = {
	key: '',
	id: -1,
	name: '',
	type: CORE_PROJECT,
};

type Action = SetAction;

const project = (state: ProjectState = initialState, action: Action): ProjectState => {
	switch (action.type) {
		case SET: {
			return freeze(action.payload);
		}
		default:
			return state;
	}
};

export default project;
